import { useUser } from "@/contexts/UserContext";
import type { AuthSession } from "@/contexts/useAuthSession";

export function useAuth(): AuthSession {
  return useUser().session;
}
